import { configureStore } from '@reduxjs/toolkit';
import { swasnaAdminApi } from '../services/api';
import swasnaAdminApiErrorHandler from '../services/api/errorHandler';
import rootReducer from './rootReducer';

const store = configureStore({
  reducer: {
    [swasnaAdminApi.reducerPath]: swasnaAdminApi.reducer,
    ...rootReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(swasnaAdminApi.middleware)
    .concat(swasnaAdminApiErrorHandler),
});

export default store;
